import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Components
import PropertiesMobileSubnav from '../PropertiesMobileSubnav';
import ErrorHandler from '../../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionHeader from '../../../../_molecules/SectionHeader';
import SectionBreadcrumb from '../../../../_molecules/SectionBreadcrumb';
import SectionBreadcrumbs from '../../../../_molecules/SectionBreadcrumbs';
import PropertyEdit from '../../../../_organisms/PropertyEdit';
import LoadingArea from '@molecules/LoadingArea';
import { SectionWrapperInner, SectionWrapperOuter } from '@styled';

// Helpers
import useProperty from '@hooks/useProperty';
import useViewer from '@hooks/useViewer';
import useDocumentTitle from '@hooks/useDocumentTitle';

const EditPropertyPage = () => {
    const history = useHistory();
    const { id } = useParams();
    const { viewer } = useViewer();
    const { data: property } = useProperty({ id });
    useDocumentTitle(property?.title ? `Edit Property - ${property.title}` : 'Edit Property');

    useEffect(() => {
        if (!viewer || !property) {
            return;
        }

        if (property.manager.recordId !== viewer.recordId) {
            history.push('/my-icsc/properties/listed');
        }
    }, [viewer, property, history]);

    if (!viewer || !property) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <PropertiesMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner>
                        <SectionHeader title="My ICSC Properties" />
                        <SectionBreadcrumbs className="mt-2">
                            <SectionBreadcrumb route="/my-icsc/properties">Properties</SectionBreadcrumb>
                            <SectionBreadcrumb route="/my-icsc/properties/listed">Listed Properties</SectionBreadcrumb>
                            <SectionBreadcrumb isActive>{property.title ?? ''}</SectionBreadcrumb>
                        </SectionBreadcrumbs>

                        <PropertyEdit graphProperty={property} />
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default EditPropertyPage;
